// @flow
/* eslint-env browser */
import React, { useEffect, useRef, type Node } from 'react';

import {
  lockBodyScroll,
  getTopScrollValue,
  resumeBodyScroll,
} from 'Components/utils/layers/stopScroll';

type BodyLockerProps = {
  children: Node,
  isLocked?: boolean,
};

export const BodyLocker = ({ isLocked = false, children }: BodyLockerProps) => {
  const bodyScrollTop = useRef(false);

  useEffect(
    () => {
      if (isLocked) {
        bodyScrollTop.current = getTopScrollValue(document);
        lockBodyScroll(document);
      }

      return () => {
        if (bodyScrollTop.current !== false) {
          resumeBodyScroll(document, bodyScrollTop.current);
        }

        bodyScrollTop.current = false;
      };
    },
    [isLocked],
  );
  return children;
};
